import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedSentimentView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'sentiment'
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeSentiment(value)
